import { call, fork, put, takeEvery } from "typed-redux-saga";
import { getAppServerClient } from "@advosys/component-app-server-client-js";
import { actions, TimeTrackEntriesActionTypes } from "./time-track-entries-store";
function* getTimeTrackEntries(action) {
    const apiResult = yield* call(getAppServerClient().finance.preparedInvoiceV2.getTimeTrackEntriesAsync, action.payload.preparedInvoiceId);
    if (apiResult.ok) {
        yield* put(actions.getTimeTrackEntriesSuccess(apiResult.data));
    }
    else {
        yield* put(actions.getTimeTrackEntriesFail(apiResult.error));
    }
}
function* watchGetTimeTrackEntriesRequest() {
    yield* takeEvery(TimeTrackEntriesActionTypes.GetTimeTrackEntriesRequest, getTimeTrackEntries);
}
export const timeTrackEntriesSagaInit = () => [fork(watchGetTimeTrackEntriesRequest)];
